<template>
  <div class="goodsDetailDlg">
    <el-dialog
      title="搜索明细数据"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <!-- <div class="goods-info" >
        <div class="title">关键词</div>
        <div class="info">{{ goodsDetail.keyword }}</div>
      </div> -->
      <div class="goods-detail">
        <!-- <div class="title">搜索明细</div> -->
        <el-tabs v-model="tabPosition" @tab-click="tabChange" size="mini">
          <el-tab-pane label="搜索趋势" name="searchTrend" />
          <el-tab-pane label="推荐SKU" name="recommendSKU" />
        </el-tabs>
        <div v-if="tabPosition == 'searchTrend'">
          <el-radio-group
            v-model="trendTabPosition"
            style="margin-bottom: 10px"
            size="mini"
            @input="trendChange"
          >
            <el-radio-button label="day">当日趋势</el-radio-button>
            <el-radio-button label="month">最近30天趋势</el-radio-button>
          </el-radio-group>

          <highcharts :options="chartOptions" v-if="chartOptions" />
        </div>
        <div v-if="tabPosition == 'recommendSKU'">
          <el-form
            ref="formTool"
            label-width="90px"
            :model="formTool"
            size="small"
            :inline="true"
          >
            <el-row style="display: flex">
              <el-form-item label="">
                <el-input v-model="formTool.name" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  v-model="formTool.date"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  size="small"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :picker-options="pickerOptions"
                  style="width: 80%"
                />
              </el-form-item>
              <div class="btn-box">
                <el-button type="primary" size="small" @click="getList(1)"
                  >查 询</el-button
                >
                <el-button size="small" @click="handleReset">重 置</el-button>
                <!-- <el-button size="small" style="float: right" @click="handleExport"
                  >导出</el-button
                > -->
              </div>
            </el-row>
          </el-form>
          <div
            class="center"
            :style="contentHeight ? `height:${contentHeight}px!important` : ''"
          >
            <MyTable
              :table-data="tableData"
              :index="index"
              :selection="selection"
              :page="page"
              :operation="operation"
              :table-option.sync="tableOption"
              @page-change="getList"
              @sort-change="sortChange"
            >
              <template slot="clik_cvr" slot-scope="scope">
                {{scope.row.clik_cvr ? parseFloat((scope.row.clik_cvr * 100)).toFixed(4) + '%' : ''}}
              </template>
            </MyTable>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import { queryGoodsSalesEcharts, excelExport } from "@/api/statistics";

export default {
  components: { MyTable },
  data() {
    return {
      dialogVisible: false,
      formTool: {
        name: "",
        date: [],
      },
      tableData: [],
      tabPosition: "searchTrend",
      trendTabPosition: "day",
      operation: false,
      selection: false,
      index: false,
      contentHeight: 400,
      tableOption: [
        // { label: "SKU编码", prop: "sku_code" },
        { label: "商户名称", prop: "shop_name" },
        { label: "商品名称", prop: "goods_name" },
        { label: "厂家", prop: "goods_factory" },
        // { label: "规格", prop: "goods_specification" },
        { label: "活动类型", prop: "activity_type_name" },
        { label: "价格", prop: "price", sortable: "custom" },
        {
          label: "点击量",
          prop: "click_cnt",
          sortable: "custom",
          customHeader: "true",
          content: "当前关键词搜索结果页该SKU点击次数合计",
        },
        // {
        //   label: "点击转化率",
        //   prop: "clik_cvr",
        //   sortable: "custom",
        //   customHeader: "true",
        //   content: "点击转化率=点击量/推荐次数*100%",
        //   slot: true
        // },
      ],
      page: {
        total: 0,
        current: 1,
        size: 30,
        pageSizes: [30, 50, 100, 500],
      },
      goodsDetail: {},
      chartOptions: undefined,
      type: 114,
      order: '1',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    };
  },
  methods: {
    init(row) {
      this.dialogVisible = true;
      this.handleReset()
      this.goodsDetail = {...row}
      this.trendChange(this.trendTabPosition)
    },
    handleClose() {
      this.dialogVisible = false;
      this.tabPosition = 'searchTrend'
    },
    setTableSecond(arr) {
      const _arr = arr;
      // 设置销售趋势图表
      let search = [];
      let click_cnt = [];
      let days = [];
      _arr.forEach((e) => {
        search.push(Number(e.search_cnt));
        if (this.trendTabPosition === 'day' ) {
          days.push(e.biz_hour);
        } else {
          days.push(e.biz_date)
        }

        click_cnt.push(Number(e.click_cnt));
      });
      this.chartOptions = {
        colors: ["#F5222D", "#F6C638"],
        credits: {
          enabled: false,
        },
        chart: {
          height: this.tableHeight - 24,
        },
        exporting: { enabled: false },
        title: {
          text: `<span style="color:#262626;font-size:16px;font-weight:600;">搜索量/点击量</span>`,
          align: "left",
        },
        yAxis: {
          title: {
            enabled: false,
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
          series: {
            dataLabels: {
              enabled: true
            },
          },
        },
        xAxis: {
          categories: days,
        },
        tooltip: {
          shared: true
        },
        series: [
          {
            name: "搜索量",
            data: search,
          },
          {
            name: "点击量",
            data: click_cnt,
          },
        ],
      };
    },
    handleReset() {
      this.chartOptions = undefined;
      this.formTool = {
        name: "",
        date: [],
      };
      const endData = new Date()
      endData.setDate(new Date().getDate() - 6)
      this.formTool.date.push(this.formatDate(endData))
      this.formTool.date.push(this.formatDate(new Date()))
    },
    tabChange(val) {
      const name = val.name
      if (name === 'recommendSKU') {
        this.getList(1)
      } else {
        this.trendChange(this.trendTabPosition)
      }
    },
    trendChange(val) {
      const param = {
        params: [this.goodsDetail.keyword],
        type: 113
      }
      if (val === 'day') {
        param.type = 113
      } else {
        param.type = 112
      }
      this.getChartData(param)
    },
    // 获取图标数据
    getChartData(param) {
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
          this.setTableSecond(res)
        } else {
          this.setTableSecond([])
        }
      });
    },
    // 表格排序
    sortChange(val) {
      this.order = this.getOrder(val.prop);
      if (val.order == "ascending") {
        this.type = 114
      } else {
        this.type = 115
      }
      this.getList();
    },
    // 根据选择的字段获取请求参数
    getOrder(val) {
      let getValue = '1'
      switch (val) {
        case 'price':
          getValue = '1'
          break
        case 'click_cnt':
          getValue = '2'
          break
        case 'clik_cvr':
          getValue = '3'
          break
        default:
          getValue = '1'
          break;
      }
      return getValue
    },
    getList(current) {
      if (current) {
        this.page.current = current;
      }

      let list = this.getParam()
      this.getTotal(list)
      this.getTable(list)
    },
    // 获取请求参数
    getParam() {
      //  [关键词,开始时间,开始时间,结束时间,结束时间,商户名称,商户名称,排序字段,每页行数,第几行开始]
      const date1 = this.correctData(this.formTool.date[0]).replace(/-/g, '')
      const date2 = this.correctData(this.formTool.date[1]).replace(/-/g, '')
      const keyword = this.goodsDetail.keyword
      return [keyword, date1, date1, date2, date2,
        this.correctData(this.formTool.name), this.correctData(this.formTool.name),
        this.correctData(this.order), this.page.size, (this.page.current - 1) * 30]
    },
    // 格式化数据
    correctData(data) {
      return data || ''
    },
    // 请求表格数据升序/降序
    getTable(list) {
      const param = {
        params: list,
        type: this.type
      }
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
          this.tableData = res;
        } else {
          this.tableData = [];
        }
      });
    },
    // 请求总数
    getTotal(list) {
      const param = {
        params: list,
        type: 116
      }
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
          this.page.total = Number(res[0].cnt);
        } else {
          this.page.total = 0;
        }
      });
    },
    handleExport() {
      const list = this.getParam()
      list.pop()
      list.pop()
      list.pop()
      const param = {
        type: 117,
        params: list
      }
      excelExport(param).then((res) => {
      });
    },
    //格式化日期：yyyy-MM-dd
    formatDate(date) {
      const myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return (myyear + "-" + mymonth + "-" + myweekday);
    },
  },
};
</script>

<style lang="scss" scoped>
.goodsDetailDlg {
  .goods-info,
  .goods-detail {
    .title {
      font-size: 16px;
      font-weight: bold;
      border-left: 3px solid red;
      padding-left: 10px;
      margin-bottom: 24px;
      color: #f6212d;
    }
  }
  .goods-detail {
    //margin-top: 32px;
    .btn-box {
      margin-left: 12px;
      flex: 1;
    }
  }

  ::v-deep .el-tabs__header {
    height: 36px;
    line-height: 36px;
    margin-bottom: 16px !important;
  }
  .center {
    ::v-deep .zt__table {
      height: 90%;
    }
  }
}
</style>
